<template>
  <BContainer
    v-if="currentUser"
    class="mb-4"
  >
    <div class="d-flex justify-content-end">
      <BBreadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <OfficerProfilePictures
      :loading="state.busy"
      :officer="officerProfile"
    />

    <RouterView :officer="officerProfile" />
  </BContainer>
</template>
<script>
import { mapGetters } from 'vuex'

import OfficerProfilePictures from '@/views/asm/officers/tasks/ProfilePictures.vue'

import MxMisc from '@/mixins/misc'
import MActivities from '@/mixins/maintenances/activities'
import MFSOfficers from '@/mixins/accounts/fsos'

import { SASMFso } from '@/services/asm'

export default {
  name: 'ASMOfficerTasksBase',

  components: {
    OfficerProfilePictures
  },

  mixins: [
    MActivities,
    MFSOfficers,
    MxMisc
  ],

  middleware: [
    'auth',
    'asm'
  ],

  metaInfo: () => ({
    title: 'Officer Tasks'
  }),

  data () {
    return {
      state: {
        busy: false,
        editing: false
      },
      officerProfile: {
        id: this.$route.params.officer || '',
        role_id: '',
        username: '',
        first_name: '',
        last_name: '',
        mobile_number: '',
        address: '',
        sso_id: '',
        email: '',
        notification_email: '',
        clusters: [],
        photo_url: '',
        active: 1
      }
    }
  },

  computed: mapGetters({
    currentUser: 'auth/user'
  }),

  mounted () {
    if (this.currentUser) {
      this.getOfficerProfile()
    }
  },

  methods: {

    async getOfficerProfile (useLoader = true) {
      this.state.busy = useLoader && true

      await SASMFso.show(this.officerProfile.id).then(
        async ({ data: { officer } }) => {
          if (!officer) {
            return this.swalInvalid(
              '<h6>Your officer profile seems to be incorrect or incomplete, please check and try again.</h6>',
              'Officer Not Found'
            ).then(
              () => {
                this.$router.push({ name: 'asm.officers' })
              }
            )
          }

          this.officerProfile = Object.assign(this.officerProfile, {
            id: officer.id,
            first_name: officer.first_name,
            last_name: officer.last_name,
            email: officer.email,
            notification_email: officer.notification_email,
            mobile_number: officer.mobile_number,
            photo_url: officer?.photo_url || '',
            clusters: officer?.clusters || [],
            role_id: officer.role_id,
            sso_id: officer.sso_id,
            active: officer.active
          })
        }
      ).finally(() => {
        this.state.busy = false
      })
    }
  }
}
</script>
